
    import store from '@/store'
    import AuthService from '@/service/AuthService'

    export default {
        name: 'TwoFactorLayer',
        emits: ['success'],
        computed: {
            certTimeStr() {
                if (this.certTime > 0) {
                    let min = Math.floor(this.certTime / 60)
                    let sec = Math.floor(this.certTime % 60)
                    return ` ${min.zf(2)}:${sec.zf(2)}`
                }
                else {
                    return '이 만료되었습니다.'
                }
            },
            globalData() {
                return store.getters.getGlobalData
            }
        },
        data() {
            return {
                visible: false,
                isLoading: false,
                USER_ACNT_NO: 0,
                CERT_REQ_CD: '',
                REQ_ID: '',
                UMS_CNT: 0,
                certTxt: '',
                certInvl: -1,
                resendInvl: -1,
                certTime: 0,
                resendTime: 0,
            }
        },
        methods: {
            show() {
                this.isLoading = true;
                this.visible = true;

                this.$nextTick(() => {
                    const input = this.$refs.smsInput as HTMLInputElement | undefined;
                    input?.focus();
                });
            },
            hide() {
                this.isLoading = false;
                this.visible = false;

                this.certTxt = '';
            },
            request(data) {
                this.USER_ACNT_NO = data.USER_ACNT_NO
                this.CERT_REQ_CD = data.CERT_REQ_CD
                this.REQ_ID = data.REQ_ID
                if (data.UMS_CNT) {
                    this.UMS_CNT = data.UMS_CNT
                }

                this.certTxt = '';

                AuthService.user_request({
                    ...data,
                }, res => {
                    if (res.RESULT > 0) {
                        this.startTimer();
                        this.show();
                    }
                    else {
                        alert(res.RESULT_MESG)
                    }
                });
            },
            approve() {
                if (!this.certTime) {
                    alert('인증 대기시간을 초과했습니다.');
                    return;
                }

                AuthService.user_cert({
                    USER_ACNT_NO: this.USER_ACNT_NO,
                    CERT_REQ_CD: this.CERT_REQ_CD,
                    REQ_ID: this.REQ_ID,
                    APVL_CNO: this.certTxt
                }, res => {
                    const { RESULT, RESULT_MESG } = res;
                    if (RESULT > 0) {
                        this.hide();

                        this.$emit('success', {
                            REQ_ID: this.REQ_ID,
                            USER_ACNT_NO: this.USER_ACNT_NO,
                        });
                    }
                    else {
                        alert(RESULT_MESG);
                        if (RESULT === -2) {
                            this.hide();
                        }
                    }
                });
            },
            resend() {
                if (this.resendTime > 0) {
                    alert(`${this.resendTime}초 경과 후 다시 인증요청을 할 수 있습니다.`);
                    return
                }
                this.request({
                    USER_ACNT_NO: this.USER_ACNT_NO,
                    CERT_REQ_CD: this.CERT_REQ_CD,
                    REQ_ID: this.REQ_ID,
                    UMS_CNT: this.UMS_CNT,
                });
            },
            startTimer() {
                const { CERT_RESEND_TIME, CERT_WAIT_TIME } = this.globalData.SYS_CONF;

                this.certTime = parseInt(CERT_WAIT_TIME)
                this.resendTime = parseInt(CERT_RESEND_TIME)

                this.certInvl = setInterval(() => {
                    this.certTime -= 1;

                    if (this.certTime < 1) {
                        clearInterval(this.certInvl);
                        this.hide();
                    }
                }, 1000)
                this.resendInvl = setInterval(() => {
                    this.resendTime -= 1;

                    if (this.resendTime < 1) {
                        clearInterval(this.resendInvl);
                    }
                }, 1000)
            }
        },
        unmounted() {
            clearInterval(this.certInvl)
            clearInterval(this.resendInvl)
        }
    }
